import api from './api';

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('adminToken') || ''}`,
});

const adminApi = {
  get:    (url)        => api.get(url,    { headers: authHeader() }),
  post:   (url, data)  => api.post(url, data,   { headers: authHeader() }),
  put:    (url, data)  => api.put(url, data,    { headers: authHeader() }),
  delete: (url)        => api.delete(url, { headers: authHeader() }),
};

export const aiApi = {
  getDashboard:   () => adminApi.get('/ai/dashboard').then(r => r.data),
  getChatHistory: () => adminApi.get('/ai/chat/history').then(r => r.data),
  clearChat:      () => adminApi.delete('/ai/chat/history').then(r => r.data),
  resolveAlert:   (id) => adminApi.put(`/ai/alerts/${id}/resolve`).then(r => r.data),
  getTodayMatches: () => adminApi.get('/ai/matches/today').then(r => r.data),

  chatStream: async (message, { onToken, onRender, onDone }) => {
    const token = localStorage.getItem('adminToken');
    const baseURL = api.defaults.baseURL;

    const res = await fetch(`${baseURL}/ai/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ message }),
    });

    if (!res.ok) {
      let errText = `HTTP ${res.status}`;
      try { const j = await res.json(); errText = j.message || errText; } catch(_) {}
      throw new Error(errText);
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      const parts = buffer.split('\n\n');
      buffer = parts.pop();

      for (const part of parts) {
        const line = part.replace(/^data: /, '').trim();
        if (!line) continue;
        try {
          const json = JSON.parse(line);
          if (json.token && onToken) onToken(json.token);
          if (json.render && onRender) onRender(json.render);
          if (json.done && onDone) onDone();
          if (json.error) throw new Error(json.error);
        } catch (_) {}
      }
    }
  },
};